import { Box, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { nanoid } from 'nanoid';
import { SkeletonFeed } from '../fl-components/skeleton';
import CreateFeed from '../components/feeds-component/Create';
import FeedContainer from '../components/feeds-component/FeedContainer';
import EmptyDashboardChart from '../components/EmptyDashboardChart';

export default function Feed({ feedDetails, editable = true }) {
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  return (
    <Box position="relative" mb={2} key={nanoid()}>
      <Stack spacing={3}>
        {editable && <CreateFeed />}
        {feedDetails === null && (selectedOrg?.id ?? selectedOrg?.orgId) && <SkeletonFeed />}
        {(feedDetails === null || feedDetails.length === 0) && (
          <EmptyDashboardChart text="Oops! seems like you don't have any feeds" />
        )}
        {feedDetails && feedDetails.map((fd) => <FeedContainer post={fd} key={fd.id} />)}
      </Stack>
    </Box>
  );
}

Feed.propTypes = {
  feedDetails: PropTypes.array,
  editable: PropTypes.bool
};
